module.exports = __webpack_public_path__ + "img/note__modal.6efd1d0e.png";